module.exports = "<div class=modal-header><button type=button class=close ng-click=modalCtrl.dismiss()>&times;</button><h3><l10n>Fare conditions</l10n></h3></div><div class=modal-body ng-repeat=\"fare in fareTypes\"><h4>{{fare.Description}}</h4><div><p>{{fare.ConditionsSummary}}</p></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=modalCtrl.close()><l10n>OK</l10n></button></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/ukrail/eurail-fare-conditions-modal/eurail-fare-conditions-modal.html
// module id = 3588
// module chunks = 0